<template>
  <div class="newDetail" style="padding-top: 50px;">
    <!--<img src="../../static/image/fanganxiangqing_title.png" class="fullWidth">-->
    <img src="../../static/image/xinwenxiangqing_title.png" class="fullWidth">
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="16">
      <div style="height: 50px;"></div>
      <table class="fullWidth">
        <tr>
          <td width="50%" class="newDetails">方案详情</td>
          <td align="right" class="font20 color99 fontfaYahei curP">当前位置：方案详情</td>
        </tr>
      </table>
      <div style="height: 50px;"></div>
      <Row>
        <Col span="16">
        <div class="fontfaYahei font20 alignCenter" style="color: #FD7B35">{{title}}</div>
        <div style="height: 10px;"></div>
        <div class="fontfaYahei color99 font12 alignCenter">来源：{{edit_user}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;时间：{{time}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{pv}}人已读</div>
        <div style="height: 10px;"></div>
        <div v-html="htmlString"></div>
        </Col>
        <Col span="8">
        <ul style="list-style: none;margin-left: 30px;border: 1px solid #e6e6e6">
          <li class="alignCenter colorW font20" style="height: 60px;background: #FD7B35;line-height: 60px;">热门文章推荐</li>
          <li v-for="(item,index) in newsList" :key="index" style="margin: 10px 15px;border-bottom: 1px solid #e6e6e6">
            <div class="fontfaYahei color33 font14 oneHang curP">
              <router-link :to="{path:linkTo,query:{newId:item.id}}" style="color:#333333">{{item.title}}
              </router-link>
            </div>
            <table class="fullWidth">
              <tr>
                <td class="fontfaYahei font12 color99" width="50%">{{item.time}}</td>
                <td class="fontfaYahei font12 color99" align="right">{{item.pv}}人已读</td>
              </tr>
            </table>
          </li>
        </ul>
        </Col>
      </Row>
      </Col>
    </Row>
    <div style="height: 50px;"></div>
    <xfck></xfck>
  </div>
</template>

<script>
  import xfck from './xfck.vue'
  export default {
    name: 'newDetail',
    data() {
      return {
        newId: this.$route.query.newId,
        title: "",
        time: "",
        edit_user: "",
        htmlString: "",
        pv: "",
        linkTo: "/proDetails",
        newsList: []
      }
    },
    mounted() {
      var that = this;
      var url = that.baseUrl + '/jianyunadmin/api.php?c=business_news_info';
      that.axios.get(url, {params: {id: that.newId}}).then(res => {
        that.pv = res.data.data.pv;
        that.htmlString = res.data.data.htmlString;
        that.edit_user = res.data.data.edit_user;
        that.title = res.data.data.title;
        that.time = that.getData.timetrans(res.data.data.time);
        res.data.data.hot_list.forEach(function (item, index) {
          item.time = that.getData.timetrans(item.time);
          that.newsList.push(item);
        });
      }).catch(error => {
        console.log(error);
      })
    },
     components:{
      xfck,
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/proDetail.vue